/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Select, Tag} from "antd";
import type {ClosableType} from "antd/es/_util/hooks/useClosable";

interface MultiSelectProps {
	value: string[];
	options: { label: string; value: string, color?: string }[];
	closable?: ClosableType;
	onChange: (values: string[]) => void;
	placeholder?: string;
}

const MultiSelect = ({ value, options, closable = true, onChange, placeholder }: MultiSelectProps) => {
	const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
		event.preventDefault();
		event.stopPropagation();
	};

	return (
		<Select
			mode="multiple"
			value={value}
			style={{ width: '100%' }}
			options={options}
			placeholder={placeholder || ''}
			onChange={onChange}
			tagRender={({ label, value: tagValue }) => (
				<Tag
					color={options.find((option) => option.value === tagValue)?.color || ''}
					onMouseDown={onPreventMouseDown}
					closable={closable}
					onClose={() => {
						const newValue = value.filter((v) => v !== tagValue);
						onChange(newValue);
					}}
					style={{ marginInlineEnd: 4 }}
				>
					{label}
				</Tag>
			)}
		/>
	);
};

export default MultiSelect;
